// this is the bed position without the _bed appended
export const bedPositionWOBed = ["door", "a", "b"]